<div class="main-container">
  <h2 class="h1-medium">Media References</h2>
  <div class="references-container">
    @for (reference of metadataReferences(); track reference.id) {
      <ng-container
        *ngTemplateOutlet="
          referenceItem;
          context: {
            $implicit: reference,
            reference: reference,
            displayText: 'File ' + reference.id,
            disabled: false,
            onDelete: deleteReference,
            showDeleteButton: true,
          }
        "
      >
      </ng-container>
    }

    @if (!store.isEditMode() && store.mediaReferencesToMerge()?.length !== 0) {
      @for (reference of store.mediaReferencesToMerge(); track reference.id) {
        <ng-container
          *ngTemplateOutlet="
            referenceItem;
            context: {
              $implicit: reference,
              reference: reference,
              displayText: 'File ' + reference.id,
              disabled: false,
              onDelete: deleteReferenceFromMerge,
              showDeleteButton: true,
            }
          "
        >
        </ng-container>
      }
    }

    @for (reference of createModelReferences(); track reference.createId; let index = $index) {
      <ng-container
        *ngTemplateOutlet="
          referenceItem;
          context: {
            $implicit: reference,
            reference: reference,
            displayText: createModelDisplayName(index),
            disabled: true,
            onDelete: deleteReference,
            showDeleteButton: true,
          }
        "
      >
      </ng-container>
    }

    @if (store.isEditMode()) {
      <div class="upload-media-section">
        <div class="restriction-disclaimer">C1 unrestricted only</div>
        <div>
          <button class="button-secondary" mat-flat-button (click)="uploadMedia()">Upload media file</button>
          <input
            #fileInput
            type="file"
            accept=".pdf,.docx,.jpg,.jpeg,.png"
            style="display: none"
            (change)="onFileSelected($event)"
          />
        </div>
        <div class="supported-formats">PDF, DOCX, JPG, PNG (max. 5MB)</div>
      </div>
    }

    @if (store.isEditMode() && store.mediaReferencesToMerge()?.length !== 0) {
      <div class="merged-references-header">Merged media references:</div>

      @for (reference of store.mediaReferencesToMerge(); track $index) {
        <ng-container
          *ngTemplateOutlet="
            referenceItem;
            context: {
              $implicit: reference,
              reference: reference,
              displayText: 'File ' + reference.id,
              disabled: false,
              onDelete: null,
              showDeleteButton: false,
            }
          "
        >
        </ng-container>
      }
    }
  </div>

  <ng-template
    #referenceItem
    let-reference="reference"
    let-displayText="displayText"
    let-disabled="disabled"
    let-onDelete="onDelete"
    let-showDeleteButton="showDeleteButton"
  >
    <div class="reference-container">
      <button
        class="text-content"
        [disabled]="disabled"
        [tabIndex]="disabled ? -1 : 0"
        (click)="!disabled && mediaReferenceHelper.previewMedia(reference.id)"
      >
        <mat-icon class="link-icon">{{ mediaReferenceHelper.mapContentTypeIcon(reference.contentType) }}</mat-icon>
        <span>{{ displayText }}</span>
      </button>

      @if (showDeleteButton && store.isEditMode()) {
        <button class="button-secondary-icon delete-button" mat-icon-button disableRipple>
          <mat-icon class="icon" (click)="onDelete(reference)">delete</mat-icon>
        </button>
      }
    </div>
  </ng-template>
</div>
